import { render, staticRenderFns } from "./BookSlotButton.vue?vue&type=template&id=53e3e01b&"
import script from "./BookSlotButton.vue?vue&type=script&lang=js&"
export * from "./BookSlotButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports